export enum StructuralElementType {
  VERTICAL = 'VERTICAL', // Columns, Walls
  HORIZONTAL = 'HORIZONTAL', // Slabs, Beams
  FOUNDATION = 'FOUNDATION', // Footings, Piles
  MASS = 'MASS', // Dams, large foundations
  OTHER = 'OTHER'
}
